<style>
    .ivu-table .demo-table-info-row td{
        color: #19be6b;
    }

</style>

<template>
    <div>

        <Card>
            <p slot="title">
                Hapus Invoice
            </p>

            <Button-group
                slot="extra">
                <Button
                    type="primary"
                    :loading="loadingSearch"
                    @click="getInvoices"
                    icon="ios-search"
                    size="small"  >
                        <span v-if="!loadingSearch">Search</span>
                        <span v-else>Wait.....</span>
                </Button>
            </Button-group>

                <Table
                    v-show="invoices.length > 0"
                    :columns="tableColumns"
                    :data="invoices"
                    no-data-text=""
                    @on-row-click="showDeleteInvoice"
                ></Table>


            <Modal v-model="modalConfirmDelete" width="80%"
            @on-cancel="confirmMarkingheadercode = ''">
                <p slot="header" style="color:#f60;text-align:center">
                    <Icon type="information-circled"></Icon>
                    <span>Konfirmasi</span>
                </p>
                <div style="text-align:left">
                    <h4>{{invoiceToDelete.markingCode}} : {{invoiceToDelete.transactionDate}}</h4>
                    <p>Partai {{ invoiceToDelete.description}} </b></p>
                    <p>Invoice Fee     : Rp <b>{{ invoiceToDelete.invoiceFee}} </b></p>
                </div>
                <div slot="footer">

                    <Button
                        type="error" size="large" long :loading="isLoadingDelete" @click="deleteInvoice"
                        >Hapus</Button>
                </div>
            </Modal>

        </Card>
    </div>
</template>

<script>
import {HTTP} from '@/components/http-lib'
import _ from 'lodash'
import moment from 'moment'
import {Money} from 'v-money'

const numeral = require('numeral');

export default {
    components : {Money},
    data: () => ({
        confirmMarkingCode : '',
        modalConfirmDelete: false,
        loadingSearch: false,
        user : {
            username : '',
            role : ''
        },
        modal : {
            deleteInvoice : false
        } ,
        invoices : [],
        invoiceToDelete: [],
        isLoadingDelete: false,
        tableColumns: [
            {
                title: 'Tgl',
                key: 'transactionDate',
                sortable: false
            },
            {
                title: 'Marking Code',
                key: 'markingCode',
                sortable: true
            },
            {
                title: 'Partai',
                key: 'description',
                sortable: false,
                width: 250
            },
            {
                title: 'Old Fee',
                key: 'invoiceFee',
                align: 'right',
                sortable: false
            },
            {
                title: 'New Fee',
                key: 'invoiceNewFee',
                align: 'right',
                sortable: false
            },
            {
                title: 'Notes',
                key: 'repricingnotes',
                sortable: false,
                width: 400
            }


        ]
    }),

    methods: {
        getInvoices: function(){
            let parent = this;
            this.loadingSearch = true;
            this.invoices = []
            HTTP
               .get('invoice/delete/show')
               .then(response => {
                    let invoices = []
                    _.forEach(response.data, function(value){
                        let invoice = {
                            invoiceId : value.invoiceid,
                            transactionDate : parent.showDateFormatted(value.transactiondate),
                            markingCode : value.markingcode,
                            invoiceFee : numeral(value.invoicefee).format('0,0'),
                            description : value.description,
                            invoiceNewFee : numeral(value.invoiceNewFee).format('0,0'),
                            repricingnotes : value.repricingnotes,
                        }
                        invoices.push(invoice);
                    });
                    this.loadingSearch = false;
                    this.invoices = invoices;
                })
                .catch(e => {
                    this.loadingSearch = false;
                    this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            });
        },
        showDateFormatted : function(stringToFormat){
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        showDeleteInvoice: function(invoiceToDelete) {
            this.invoiceToDelete = invoiceToDelete
            this.modalConfirmDelete = true
        },
        deleteInvoice: function() {
            let invoiceToDelete = this.invoiceToDelete;
            this.isLoadingDelete = true;
            HTTP
            .post('invoice/delete', {
                invoiceid: invoiceToDelete.invoiceId
            })
            .then(response => {
                this.isLoadingDelete = false;
                let parent = this;
                this.modalConfirmDelete = false
                this.loadingPost = false

                if(response.data.isSuccess){
                    this.$Message.success({
                        content: 'Data Telah Terhapus',
                        duration: 4
                    });

                    this.getInvoices();
                } else {
                    var paymentsDesc = 'Hapus pembayaran berikut dahulu : <br/>';
                    _.forEach(response.data.payments, function(payment, index){

                        var paymentAmount = numeral(payment.amount).format('0,0')
                        var paymentDate = parent.showDateFormatted(payment.paymentDate)

                        paymentsDesc +=  index + 1 + '. Tgl ' + paymentDate + ', Rp ' + paymentAmount;
                        paymentsDesc += '<br/>';
                    });

                    this.$Notice.error({
                        title: "Error",
                        desc: paymentsDesc,
                        duration: 0
                    });

                }

            })
            .catch(e => {
                this.modalConfirmDelete = false
                this.isLoadingDelete = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        }
    },
  created() {
    this.user.role = localStorage.getItem('user.role')
  }
}

</script>



// WEBPACK FOOTER //
// InvoiceDelete.vue?6a5a1007